module.exports = __webpack_public_path__ + "static/media/ftlgroup.dccb2916.webp";